import { useMutation } from '@tanstack/react-query';
import { resolveClientRegistrationErrorCode } from '../partnerTokenExchange.utils';
import { registerOAuthClient } from '@/services/partner-token-exchange.service';
import type {
  OAuthClientCredentials,
  OAuthClientRegistrationError,
  OAuthClientRegistrationRequest,
} from '@/services/partner-token-exchange.types';

export type ClientRegistrationValues = OAuthClientRegistrationRequest;

interface UseClientRegistrationMutationArgs {
  onSuccess: (credentials: OAuthClientCredentials) => void;
  onError: (
    errorCode: keyof typeof OAuthClientRegistrationError | undefined,
  ) => void;
}

const useClientRegistrationMutation = ({
  onSuccess,
  onError,
}: UseClientRegistrationMutationArgs) =>
  useMutation({
    mutationFn: (values: ClientRegistrationValues) =>
      registerOAuthClient(values),
    onSuccess: ({ credentials }) => onSuccess(credentials),
    onError: (error) => onError(resolveClientRegistrationErrorCode(error)),
  });

export default useClientRegistrationMutation;
